import React from "react";

import { ReferenceType } from "@floating-ui/react";

type DropdownAnchorChildProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onFocus: () => void;
  onBlur: () => void;
  ref: (node: ReferenceType | null) => void;
  "aria-expanded": boolean;
};

export type DropdownAnchorProps = Partial<
  Omit<DropdownAnchorChildProps, "ref" | "aria-expanded">
> & {
  isOpen?: boolean;
  setReference?: (node: ReferenceType | null) => void;
  children: (props: DropdownAnchorChildProps) => JSX.Element;
};

export const DropdownAnchor = ({
  children,
  setReference,
  onBlur,
  onFocus,
  setIsOpen,
  isOpen = false,
}: DropdownAnchorProps) => {
  if (!setReference || !onBlur || !onFocus || !setIsOpen) {
    throw Error("DropdownAnchor should be used as direct child of Dropdown");
  }

  return children({ ref: setReference, onBlur, onFocus, setIsOpen, "aria-expanded": isOpen });
};
